export default __webpack_public_path__ + "static/media/GalanoGrotesque.df7260ba.woff";